import React, { useEffect, useRef } from 'react';
import isDate from 'lodash/isDate';
import { Calendar } from 'primereact/calendar';
import classNames from 'classnames';
import isFunction from 'lodash/isFunction';
import Analytics from '../../utils/Analytics';
import { SegmentEventTypes } from '../../data/tracking';
import LabelWrapper from '../LabelWrapper.component';

export const WrappedCalendar = props => {
	const {
		className,
		isInputInvalid,
		dateFormat,
		dataqa = 'common',
		name,
		onChange,
		...config
	} = props;

	const inputCalendarClassName = classNames(className, {
		'invalid-component': isInputInvalid,
	});

	const inputEl = useRef(null);

	useEffect(() => {
		if (inputEl?.current) {
			// only allow numbers and forward slash
			inputEl.current.addEventListener('keypress', e => {
				if (e.which !== 47 && (e.which < 48 || e.which > 57)) {
					e.preventDefault();
				}
			});
		}
	}, []);

	const clickHandler = e => {
		Analytics.trackSegmentEvent({
			trackingData: {
				field_type: 'calendar',
				field_name_dataqa: `ui-calendar-${dataqa}`,
				field_value: e.target?.value,
			},
			eventType: SegmentEventTypes.UserInputCompleted,
		});

		if (isFunction(onChange)) {
			onChange(e);
		}
	};

	return (
		<div className="common-ui-calendar">
			<Calendar
				inputRef={inputEl}
				className={inputCalendarClassName}
				data-qa={`ui-calendar-${dataqa}`}
				dataqa={`ui-calendar-${dataqa}`}
				dateFormat={dateFormat}
				name={name}
				showOnFocus={false}
				showIcon
				icon="calendar-icon"
				onChange={e => isDate(e.target?.value) && clickHandler(e)}
				{...config}
				showButtonBar
			/>
		</div>
	);
};

export const WrappedCalendarWithLabel = LabelWrapper(WrappedCalendar);
